/**
 * use-platform-landing.ts — Hooks cho Platform → Trang giới thiệu (super-admin).
 * Backend: ecdp_backend_source/src/modules/platform/landing-page-routes.ts
 */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { platformApi } from '@/lib/platform-client'

export interface PlatformLanding {
  /** true = đang dùng bản HTML tải lên; false = bản mặc định đi kèm mã nguồn (/landing/index.html). */
  custom: boolean
  html: string
  videoUrl: string
  updatedAt: string | null
}

const KEY = ['platform', 'landing'] as const

export function usePlatformLanding() {
  return useQuery<PlatformLanding>({
    queryKey: KEY,
    queryFn: async () => (await platformApi.get<PlatformLanding>('/platform/landing')).data,
  })
}

/** `html: null` = quay về bản mặc định. Chỉ gửi trường cần đổi. */
export function useSaveLanding() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (input: { html?: string | null; videoUrl?: string }) => (await platformApi.put<PlatformLanding>('/platform/landing', input)).data,
    onSuccess: (data) => qc.setQueryData(KEY, data),
  })
}
